import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminGuard = ({ children }: { children: React.ReactNode }) => {
    const token = localStorage.getItem('admin_token');
    if (!token) return <Navigate to="/admin/login" replace />;
    return <>{children}</>;
};

export default AdminGuard;
